export enum TOOL_TYPE {
  AI_VIDEO_GENERATOR = 'ai-video-generator',
  AI_ANIMATION_GENERATOR = 'ai-animation-generator',
  AI_IMAGE_ANIMATOR = 'ai-image-animator',
  AI_AD_GENERATOR = 'ai-ad-generator',
  AI_HUG_GENERATOR = 'ai-hug-generator',
  AI_KISSING_GENERATOR = 'ai-kissing-generator',
  AI_TIKTOK_VIDEO_GENERATOR = 'ai-tiktok-video-generator',
  AI_DANCE_GENERATOR = 'ai-dance-generator',
  AI_ANIME_VIDEO_GENERATOR = 'ai-anime-video-generator',
  AI_CARTOON_VIDEO_GENERATOR = 'ai-cartoon-video-generator',
  AI_FIGHT_GENERATOR = 'ai-fight-generator',
  AI_MEME_GENERATOR = 'ai-meme-generator',
  AI_REEL_GENERATOR = 'ai-reel-generator',
}

export type ToolType = (typeof TOOL_TYPE)[keyof typeof TOOL_TYPE];

export type ToolConfig = {
  link: string;
  video?: {
    url: string;
    poster: string;
    /** 窄屏（同 VideoLazyLoad / BREAKPOINTS.SM_MAX）封面；不传则全程用 poster */
    mobileUrl?: string;
    mobilePoster?: string;
  };
  image?: {
    src: string;
    mobileSrc?: string;
  };
  features: string[];
  generates: { src: string; className: string; imgClassName: string }[];
  steps: string[];
  generateNow: string;
};

export type ContentItem = {
  title: string;
  description: string;
};

export type ToolItem = {
  title: string;
  description: string;
  features: ContentItem[];
  generates: ContentItem[];
  steps: {
    title: string;
    list: ContentItem[];
  };
  faqs: {
    title: string;
    list: {
      question: string;
      answer: string;
    }[];
  };
  generateNow: {
    title: string;
  };
};

export interface HeadVideoProps {
  clsName?: string;
  toolKey: ToolType;
  toolConfig: ToolConfig;
}

export type FeatureCardProps = ContentItem & {
  image: string;
  className?: string;
};
